import { render, staticRenderFns } from "./CloseCTT.vue?vue&type=template&id=3d71bf05&scoped=true"
import script from "./CloseCTT.vue?vue&type=script&lang=js"
export * from "./CloseCTT.vue?vue&type=script&lang=js"
import style0 from "./CloseCTT.vue?vue&type=style&index=0&id=3d71bf05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d71bf05",
  null
  
)

export default component.exports